export const selectFilters = (reportKey) => (state) => state.reports[reportKey].filters;
export const selectParams = (reportKey) => (state) => state.reports[reportKey].params;
export const selectData = (reportKey) => (state) => state.reports[reportKey].data;
export const selectError = (reportKey) => (state) => state.reports[reportKey].error;
export const selectLoading = (reportKey) => (state) => state.reports[reportKey].loading;